import { classifyUserAgent } from "@/utils/embeddedBrowser";

// A three-value browser class for login telemetry. The login forms send it as
// a hidden field; the server falls back to the request's User-Agent. Never the
// raw User-Agent: only these values reach analytics.

export const LOGIN_BROWSER_CLASSES = ["meta_inapp", "other_inapp", "browser"] as const;
export type LoginBrowserClass = (typeof LOGIN_BROWSER_CLASSES)[number];

// In-app browsers of Meta's apps (Facebook, Messenger, Instagram, WhatsApp).
const META_IN_APP_REASONS = new Set([
  "facebook-in-app-browser",
  "instagram-in-app-browser",
  "whatsapp-in-app-browser",
]);

// WeChat's User-Agent token "MicroMessenger" contains "Messenger", so the
// shared classifier reports it as Facebook / Messenger. It is not Meta's.
const WECHAT_USER_AGENT = /MicroMessenger/i;

export function getLoginBrowserClass(userAgent: string): LoginBrowserClass {
  const fingerprint = classifyUserAgent(userAgent);
  if (fingerprint.context !== "embedded") {
    return "browser";
  }
  if (WECHAT_USER_AGENT.test(userAgent)) {
    return "other_inapp";
  }
  return META_IN_APP_REASONS.has(fingerprint.reason) ? "meta_inapp" : "other_inapp";
}

export function parseLoginBrowserClass(value: unknown): LoginBrowserClass | null {
  return LOGIN_BROWSER_CLASSES.find((browserClass) => browserClass === value) ?? null;
}
